module.exports = __webpack_public_path__ + "static/media/page-bg.8cba41cd.jpg";